<template>
  <div v-if="tabData.length > 1||isNoThanOne" :class="size == 'mini' ? 'mini-tabs' : ''">
    <el-tabs
      v-if="permissionsLevel == 1"
      @tab-click="handleSwitch"
      v-model="tabIndex"
    >
      <el-tab-pane
        v-for="(item, index) in tabData"
        :label="item.label"
        :key="index"
        :name="String(item.value)"
      >
      </el-tab-pane>
    </el-tabs>
    <div v-else-if="permissionsLevel == 2" class="sub-tab">
      <div
        v-for="(item, index) in tabData"
        :class="[{ active: tabIndex == item.value }, 'sub-tab-item']"
        :key="item.value"
        @click="handleSwitch(item)"
      >
        <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabInfo: {
      type: Array,
      default: () => [],
    },
    isReturnObj: {
      type: Boolean,
      default: false,
    },
    permissionsLevel: {
      type: Number,
      default: 1,
    },
    newDefaultIndex: {
      type: String,
      default: ""
    },
    isDefaultIndex: {
      type: Boolean,
      default: false,
    },
    defaultIndex: {
      type: [String, Number],
      default: ""
    },
    isNoThanOne: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "medium"
    }
  },
  data() {
    return {
      tabData: [],
      tabIndex: null,
      valType: null,
    };
  },
  watch: {
    tabInfo: {
      handler(newVal) {
        const permissions = JSON.parse(
          sessionStorage.getItem("sellerPlatform")
        ).permissions;
        // 根据权限过滤数据
        this.tabData = this.tabInfo.filter(
          (tab) => !tab.permissions || permissions.includes(tab.permissions)
        );
        // 默认选中第一项
        if (this.tabData.length) {
          this.tabIndex = String(this.tabData[0].value);
          this.valType = typeof this.tabData[0].value;
        }

        if (this.valType === "number") {
          this.$emit("tabIndex", Number(this.tabIndex));
        } else this.$emit("tabIndex", this.tabIndex);
      },
      immediate: true,
    },
    // 外部传入默认选中项时同步内部高亮（isDefaultIndex 写法）
    defaultIndex: {
      handler(newVal) {
        if (newVal !== "" && newVal !== null && newVal !== undefined) {
          this.tabIndex = String(newVal);
        }
      },
      immediate: true,
    },
    // 外部传入默认选中项时同步内部高亮（newDefaultIndex 写法）
    newDefaultIndex: {
      handler(newVal) {
        if (newVal !== "" && newVal !== null && newVal !== undefined) {
          this.tabIndex = String(newVal);
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleSwitch(obj) {
      const val = this.permissionsLevel == 1 ? this.tabData[obj.index] : obj;
      if (this.valType === "number") {
        val.value = Number(val.value);
      } else if (this.valType === "string") {
        val.value = String(val.value);
      }
      this.tabIndex = String(val.value);
      this.$emit("input", this.tabIndex);
      if (this.isReturnObj) {
        this.$emit("switch", val);
      } else {
        this.$emit("switch", val.value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mini-tabs{
  .sub-tab{
    height: 32px;
    padding: 0 5px;
  }
  .sub-tab-item{
    height: 24px;
    line-height: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }
}
.sub-tab {
  height: 42px;
  background: #f5f5f7;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  padding: 4px;
  &-item {
    height: 34px;
    line-height: 34px;
    border-radius: 2px;
    padding: 0px 12px;
    text-align: center;
    cursor: pointer;
    font-size: $main-size !important;
    color: $text-6 !important;
    font-weight: normal !important;
    // font-family: 'PingFang SC';
  }
  .active {
    background: #ffffff;
    font-size: $main-size !important;
    color: $text-color !important;
  }
}
</style>
